import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PagesConfigPresorteoCoreRoutingModule } from './pages-config-presorteo-core-routing.module';
import { PageConfigPresorteoEditComponent } from './page-config-presorteo-edit/page-config-presorteo-edit.component';
import { PageConfigPresorteoListComponent } from './page-config-presorteo-list/page-config-presorteo-list.component';
import { ButtonModule } from 'primeng/button';
import { ConfigPresorteoListModule } from '../../components/config-presorteo/config-presorteo-list/config-presorteo-list.module';
import { ConfigPresorteoEditModule } from '../../components/config-presorteo/config-presorteo-edit/config-presorteo-edit.module';
import { PageConfigPresorteoCreateComponent } from './page-config-presorteo-create/page-config-presorteo-create.component';


@NgModule({
  declarations: [
    PageConfigPresorteoEditComponent,
    PageConfigPresorteoListComponent,
    PageConfigPresorteoCreateComponent
  ],
  imports: [
    CommonModule,
    PagesConfigPresorteoCoreRoutingModule,
    ButtonModule,
    ConfigPresorteoListModule,
    ConfigPresorteoEditModule
  ]
})
export class PagesConfigPresorteoCoreModule { }
